/**
 * @file PagedTable.js
 * @module src/js/components/PagedTable
 * @description
 * **A reusable paged table component for the EDALab frontend.**
 * - Displays a table with optional category and number pagination.
 * - Includes an optional search bar for filtering table content.
 * - Supports theming with light and dark styles.
 * - Temporarily provides a link to the legacy website version during transition.
 *
 * @version
 * <p>
 *  2025-11-28: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import ThemeToggledWrapper from "../components/ThemeToggledWrapper";
import { NewTab } from "./UtilityComponents";
import { toKebabCase } from "./UtilityComponents";

// TODO: Delete the oldWebsiteLink prop after the new website is fully functional.
export default function PagedTable({
    header,
    headerRef,
    categoryPagination = null,
    numberPagination = null,
    table,
    searchBar = null,
    oldWebsiteLink = null,
}) {
    return (
        <ThemeToggledWrapper id={toKebabCase(header)} lightStyle={5} darkStyle={4}>
            <div className="inner">
                <header className="major special" ref={headerRef}>
                    <h2>{header}</h2>
                    {searchBar}
                </header>
                {/* TODO: Delete the following {...} block after the new website is fully functional. */}
                {oldWebsiteLink && (
                    <center style={{ marginBottom: '2em' }}>
                        The website is under construction. Please come back later.<br />
                        Click <NewTab href={oldWebsiteLink}>here</NewTab> to redirect to the legacy version of this page.
                    </center>
                )}
                {categoryPagination}
                {categoryPagination && <br />}
                {numberPagination}
                {numberPagination && <br />}
                {table}
                {numberPagination}
                {categoryPagination && <br />}
                {categoryPagination}
            </div>
        </ThemeToggledWrapper>
    );
}
